import { useMutation } from "@tanstack/react-query";
import { useJwt, useRootPath } from "~/stores/sessionStore";

/**
 * Resend the Google Ads account invitation.
 */
export function useResendInvite() {
  const jwt = useJwt();
  const rootPath = useRootPath();

  return useMutation({
    mutationFn: async () => {
      const response = await fetch(`${rootPath}/api/v1/google/resend_invite`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.error || "Failed to resend invite");
      }

      return response.json();
    },
  });
}
